var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn btn-block btn-lg btn-primary",class:{'disabled': !_vm.canBuy},attrs:{"disabled":!_vm.canBuy},on:{"click":_vm.buyProduct}},[_vm._v(" Comprar ")])}
var staticRenderFns = []

export { render, staticRenderFns }